import { render, staticRenderFns } from "./BannerEditor.vue?vue&type=template&id=d6b731b6&scoped=true&lang=pug&"
import script from "./BannerEditor.vue?vue&type=script&lang=js&"
export * from "./BannerEditor.vue?vue&type=script&lang=js&"
import style0 from "./BannerEditor.vue?vue&type=style&index=0&id=d6b731b6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b731b6",
  null
  
)

/* custom blocks */
import block0 from "./BannerEditor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports